import React, { useState, useEffect } from 'react';
import { getTranslations } from '../../../../../../services/languageUtils';
import CashOutService from '../../../../../../services/Celcoin/dinamicCashOutService';
import AccountManagerService from '../../../../../../services/Celcoin/accountManagerService';

const Modal = ({ children, onClose, colors }) => {
  const modalStyles = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0,0,0,0.6)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 999,
    },
    content: {
      backgroundColor: '#fff',
      padding: '2rem',
      borderRadius: '10px',
      maxWidth: '500px',
      width: '90%',
      boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
    },
    closeButton: {
      marginTop: '1.5rem',
      backgroundColor: '#ccc',
      color: '#000',
      padding: '8px 16px',
      border: 'none',
      borderRadius: '5px',
      cursor: 'pointer',
    },
  };

  return (
    <div style={modalStyles.overlay}>
      <div style={modalStyles.content}>
        {children}
        <button onClick={onClose} style={modalStyles.closeButton}>Fechar</button>
      </div>
    </div>
  );
};

function TransferTypeBankAccount({ sendPayment, loadingTranfer, updateValueTransfer, currentBalance }) {
  const [translations, setTranslations] = useState({});
  const [formData, setFormData] = useState({
    name: '',
    bankCode: '',
    branch: '',
    account: '',
    taxNumber: '',
    value: '',
    message: '',
    identifier: '',
  });
  const [loading, setLoading] = useState(false);
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [colors, setColors] = useState({
    primary: "#1c787e",
    secondary: "#061B2B"
  });

  // Seleção de cores por tema
  const selectColors = (theme) => {
    const themes = {
      zicredit: {
        primary: "#FFCC00",
        secondary: "#061B2B"
      },
      default: {
        primary: "#1c787e",
        secondary: "#061B2B"
      }
    };
    return themes[theme] || themes.default;
  };

  const verifyDomain = (domain) => {
    const hostname = window.location.hostname;
    return hostname.includes(domain);
  };

  useEffect(() => {
    if (verifyDomain("zicredit.com")) {
      setColors(selectColors("zicredit"));
    } else {
      setColors(selectColors("default"));
    }

    const loadTranslations = async () => {
      const trans = await getTranslations(localStorage.getItem('language') || 'pt');
      setTranslations(trans);
    };
    loadTranslations();
  }, []);

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const generateId = () => {
    const timestamp = Date.now().toString(36);
    const random = Math.random().toString(36).substring(2, 10);
    return `${timestamp}-${random}`.toUpperCase();
  };

  const handleSubmit = async () => {
    if (formData.value) {
      updateValueTransfer(parseFloat(formData.value));
    }

    sendPayment(2);
  };

  const buttonStyle = {
    marginTop: '1rem',
    backgroundColor: colors.primary,
    color: 'white',
    padding: '10px 20px',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
  };

  return (
    <div style={{ padding: '1rem' }}>
      <h3><b>Transferência via Dados Bancários</b></h3>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', maxWidth: '500px' }}>
        <input
          placeholder="Nome do Recebedor"
          value={formData.name}
          onChange={(e) => handleChange('name', e.target.value)}
          style={{ padding: '10px', fontSize: '14px' }}
        />
        <input
          placeholder="Código do Banco (3 dígitos)"
          value={formData.bankCode}
          onChange={(e) => handleChange('bankCode', e.target.value)}
          style={{ padding: '10px', fontSize: '14px' }}
        />
        <input
          placeholder="Agência"
          value={formData.branch}
          onChange={(e) => handleChange('branch', e.target.value)}
          style={{ padding: '10px', fontSize: '14px' }}
        />
        <input
          placeholder="Conta (sem hífen)"
          value={formData.account}
          onChange={(e) => handleChange('account', e.target.value)}
          style={{ padding: '10px', fontSize: '14px' }}
        />
        <input
          placeholder="CPF ou CNPJ"
          value={formData.taxNumber}
          onChange={(e) => handleChange('taxNumber', e.target.value)}
          style={{ padding: '10px', fontSize: '14px' }}
        />
        <input
          placeholder="Valor (Ex: 150.50)"
          value={formData.value}
          onChange={(e) => handleChange('value', e.target.value)}
          style={{ padding: '10px', fontSize: '14px' }}
        />
        <input
          placeholder="Mensagem (opcional)"
          value={formData.message}
          onChange={(e) => handleChange('message', e.target.value)}
          style={{ padding: '10px', fontSize: '14px' }}
        />

        <button onClick={handleSubmit} style={buttonStyle} disabled={loading}>
          <b>{loading ? 'Enviando...' : 'Efetuar Pagamento'}</b>
        </button>
      </div>

      {successModalOpen && (
        <Modal onClose={() => setSuccessModalOpen(false)} colors={colors}>
          <h2><center><b>Pagamento realizado com sucesso!</b></center></h2>
          <p>Seu pagamento foi processado corretamente.</p>
        </Modal>
      )}
    </div>
  );
}

export default TransferTypeBankAccount;
